<template>    
    <div class="tracking">
        <HeaderNavMenu currentActiveName="Home"/>      
        <!-- <NewestTracNodePanel orderCode='订单号' trackNo='跟踪号' nodeStatus='最新轨迹'/> -->
        <div style="background-color: #f8f8f8;min-height:500px;">
            <Row>
                <Col span="17" style="margin-top:10px;">
                    <Tabs value="name1" :animated="false" :loading="trackLoading" style="background-color: #fff;margin-left:20px;">
                        <TabPane :label="$t('All')+' ('+AllCount+')'" name="name1">
                            <Table :columns="track_columns" :data="track_data" @on-row-click="(row, index) =>{expandTrackDetail(row, index,'all')}"></Table>
                        </TabPane>
                        <TabPane :label='this.$t("Receivedin")+" ("+ReceivedinCount+")"' name="name2">                            
                            <Table :columns="track_columns" :data="track_data_Receivedin" 
                            @on-row-click="(row, index) =>{track_data_Receivedin[index]._expanded=!track_data_Receivedin[index]._expanded}"></Table>
                        </TabPane>
                        <TabPane :label='this.$t("InTransit")+" ("+InTransitCount+")"' name="name3">                            
                            <Table :columns="track_columns" :data="track_data_InTransit" 
                            @on-row-click="(row, index) =>{track_data_InTransit[index]._expanded=!track_data_InTransit[index]._expanded}"></Table>
                        </TabPane>
                        <TabPane :label='this.$t("PickUp")+" ("+PickUpCount+")"' name="name4">                            
                            <Table :columns="track_columns" :data="track_data_PickUp"
                            @on-row-click="(row, index) =>{track_data_PickUp[index]._expanded=!track_data_PickUp[index]._expanded}"></Table>
                        </TabPane>
                        <TabPane :label='this.$t("Delivered")+" ("+DeliveredCount+")"' name="name5">                            
                            <Table :columns="track_columns" :data="track_data_Delivered"
                            @on-row-click="(row, index) =>{track_data_Delivered[index]._expanded=!track_data_Delivered[index]._expanded}"></Table>
                        </TabPane>
                        <TabPane :label='this.$t("Undelivered")+" ("+UndeliveredCount+")"' name="name6">                            
                            <Table :columns="track_columns" :data="track_data_Undelivered"
                            @on-row-click="(row, index) =>{track_data_Undelivered[index]._expanded=!track_data_Undelivered[index]._expanded}"></Table>
                        </TabPane>
                        <TabPane :label='this.$t("Alert")+" ("+AlertCount+")"' name="name7">                            
                            <Table :columns="track_columns" :data="track_data_Alert"
                            @on-row-click="(row, index) =>{track_data_Alert[index]._expanded=!track_data_Alert[index]._expanded}"></Table>
                        </TabPane>
                        <TabPane :label='this.$t("Returned")+" ("+ReturnedCount+")"' name="name8">                            
                            <Table :columns="track_columns" :data="track_data_Returned"
                            @on-row-click="(row, index) =>{track_data_Returned[index]._expanded=!track_data_Returned[index]._expanded}"></Table>
                        </TabPane>
                    </Tabs>
                </Col>
                <Col span="7" style="margin-top:10px;">
                    <div class="right_search">
                        <Input style="height: 200px;width: 80%;" type="textarea" :rows="10" v-model="trackingNumbers" :placeholder="$t('PleaseEnterNumbers')" />                                               
                    </div>
                    <br/>
                    <Button type="info"  icon="ios-search" long v-on:click="tracking"  style="height: 40px;width: 80%;margin-top:20px;">{{$t("btn_track")}}</Button>
                </Col>
            </Row>
        </div>
        <FooterComponent />
    </div>
</template>

<script>
// @ is an alias to /src
import HeaderNavMenu from '@/components/HeaderNavMenu.vue'
import FooterComponent from '@/components/FooterComponent.vue'
import NewestTracNodePanel from '@/components/NewestTracNodePanel.vue'
import TrackDetailExpandRow from '@/components/TrackDetailExpandRow.vue'

export default {
  name: 'tracking',
  components: {
    HeaderNavMenu,
    FooterComponent,
    NewestTracNodePanel,
    TrackDetailExpandRow
  },
  data: function () {
    return {
      trackingNumbers:'',
      trackLoading:false,
      AllCount:0,
      ReceivedinCount:0,
      InTransitCount:0,
      PickUpCount:0,
      DeliveredCount:0,
      UndeliveredCount:0,
      AlertCount:0,
      ReturnedCount:0,
      track_data: [],
      track_data_Receivedin: [],
      track_data_InTransit: [],
      track_data_PickUp: [],
      track_data_Delivered: [],
      track_data_Undelivered: [],
      track_data_Alert: [],
      track_data_Returned: [],
      track_columns:[                    
                    {
                        title: this.$t("OrderCode"),
                        key: "OrderCode",
                        //fixed: "left",
                        width: 160
                    },
                    {
                        title: this.$t("TrackingNumber"),
                        key: 'TrackingNumber',
                        width: 210
                    },
                    {
                        title: this.$t("NewestTrack"),
                        key: 'NewestTrack',
                        width: 420
                    },
                    {
                        title: this.$t("Status"),
                        key: 'StatusStr',
                        width: 90
                    },
                    {
                        type: 'expand',
                        render: (h, params) => {
                            return h(TrackDetailExpandRow, {
                                props: {
                                    row: params.row
                                }
                            })
                        },
                        width: 50
                    }
                ]
    }
  },
  created() {
      this.trackingNumbers=this.$store.state.trackingNumbers;
      this.tracking();      
      console.log(process.env.NODE_ENV);
    },
  methods: {
    tracking: function () {
        this.trackLoading=true;
        //setTimeout(function(){alert("加载完成！");},1000);
        if(this.trackingNumbers!==null&&this.trackingNumbers.length>1){
        var codes=this.trackingNumbers.replace(new RegExp("\t","gm"),"");
        var codeArray=codes.split('\n');
        if(codeArray.length>80){
            this.$Message.warning(this.$t('Max_Query_Count_Tips'));
            return;
        }
        this.$Loading.start();
        //开发环境
        if(process.env.NODE_ENV==="development"){            
              
        //mock    
        this.track_data=[];
        for(var i=0;i<codeArray.length;i++){
            if(codeArray[i]===''){
                continue;
            }
            var trackNode={
                OrderCode:codeArray[i],
                TrackingNumber:codeArray[i],
                Status:"已签收",
                NewestTrack:"2019-05-28 派送成功，xxx签收 sdfasdfasdfasdfsdafa sdfasdf asdfas dfas fasdfas fasdf asfda",
                ToCountryName:"美国",
                ChannelCode:"IPEXPT",
                _expanded:false,
                NodeList:[]
            };
            for(var j=0;j<10;j++){
                var nodeItem={
                    NodeTrack:"节点xxxxxxxxxxx xxxxxxxx xxxxxxxx      xxxxxxx xxxx 节点"+(j+1),
                    Time:'2019-05-01 00:00:'+j
                }
                trackNode.NodeList.push(nodeItem);
            }
            this.track_data.push(trackNode);            
            this.track_data_Receivedin.push(trackNode);    
        }
        //mock end
        }
        else{
        var codeStr=codeArray.join(";");//分号分开
        //var apiUrl="/TrackNo/GetMultipleOrderTrackInfo?rettype=json&trackno="+codeStr;
        var apiUrl="/TrackingWeb/GetTrackInfo?codes="+codeStr;
        this.$api.get(apiUrl, null, jsonData => {
            debugger
                this.track_data=[];
                if(jsonData.length<1){
                    return;
                }
                this.AllCount=jsonData.length;
                this.ReceivedinCount=0;
                this.InTransitCount=0;
                this.PickUpCount=0;
                this.DeliveredCount=0;
                this.UndeliveredCount=0;
                this.AlertCount=0;
                this.ReturnedCount=0;
                for(var i=0;i<jsonData.length;i++){
                    if(jsonData[i].orderCode===''){
                        continue;
                    }
                    if(jsonData[i].trackingData===null||jsonData[i].trackingData.length<1){
                        continue;
                    }
                    var trackNode={
                        OrderCode:jsonData[i].orderCode,
                        TrackingNumber:jsonData[i].trackNo,
                        Status:jsonData[i].status,
                        NewestTrack:jsonData[i].trackingData[0].track_string,
                        ToCountryName:jsonData[i].toCountry,
                        ChannelCode:jsonData[i].channelCode,
                        _expanded:false,//默认不展开明细
                        NodeList:[]
                    };                    
                    	// 0 '未上网' 
                        // 2 '派送中' 
                        // 3 '到达待取' 
                        // 4 '已签收' 
                        // 5 '派送失败' 
                        // 6 '已丢失' 
                        // 7 '关税异常' 
                        // 8 '其他异常' 
                        // 9 '已退件' 
                    if(trackNode.Status===0||trackNode.Status===1){
                        trackNode.StatusStr=this.$t("Receivedin");
                        this.ReceivedinCount++;
                        this.track_data_Receivedin.push(trackNode);    
                    }
                    else if(trackNode.Status===2){
                        trackNode.StatusStr=this.$t("InTransit");
                        this.InTransitCount++;
                        this.track_data_InTransit.push(trackNode);  
                    }
                    else if(trackNode.Status===3){
                        trackNode.StatusStr=this.$t("PickUp");
                        this.PickUpCount++;
                        this.track_data_PickUp.push(trackNode);  
                    }
                    else if(trackNode.Status===4){
                        trackNode.StatusStr=this.$t("Delivered");
                        this.DeliveredCount++;
                        this.track_data_Delivered.push(trackNode);  
                    }
                    else if(trackNode.Status===5){
                        trackNode.StatusStr=this.$t("Undelivered");
                        this.UndeliveredCount++;
                        this.track_data_Undelivered.push(trackNode);  
                    }
                    else if(trackNode.Status===6){
                        trackNode.StatusStr=this.$t("Alert");
                        this.AlertCount++;
                        this.track_data_Alert.push(trackNode);  
                    }
                    else if(trackNode.Status===7){
                        trackNode.StatusStr=this.$t("Alert");
                        this.AlertCount++;
                        this.track_data_Alert.push(trackNode);  
                    }
                    else if(trackNode.Status===8){
                        trackNode.StatusStr=this.$t("Alert");
                        this.AlertCount++;
                        this.track_data_Alert.push(trackNode);  
                    }
                    else if(trackNode.Status===9){
                        trackNode.StatusStr=this.$t("Returned");
                        this.ReturnedCount++;
                        this.track_data_Returned.push(trackNode);  
                    }
                    for(var j=0;j<jsonData[i].trackingData.length;j++){
                        var nodeItem={
                            NodeTrack:jsonData[i].trackingData[j].track_string,
                            Time:jsonData[i].trackingData[j].track_timeStr
                        }
                        trackNode.NodeList.push(nodeItem);
                    }
                    this.track_data.push(trackNode);            
                }
            });
        } 
            
      }
      //this.trackLoading=false;
      this.$Loading.finish();
    
    },
    expandTrackDetail:function(row,index,tableName){
        //alert(row);
        //console.log(tableName);
        //console.log(row);
        //console.log(row._expanded);
        //row._expanded=!row._expanded;
        //console.log(index);
        //点击展开明细
        if(tableName==='all'){            
            this.track_data[index]._expanded=!this.track_data[index]._expanded;
        }
    }
  }
}
</script>


<style scoped>
.tracking{
 background-color:white;
}
div .right_search{
    margin: 10px 5;
}
/* input .right_search{
    height: 200px;
    width: 100px;
} */
</style>